import history from '../../../../history';
import { extractDataFromArray, extractNameFromArray, showFormatedDate, showFormattedTime, showFormatedDateandTime, alertConfirmation } from '../../../../actions/utilAction';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { createClaimAction, getAppointmentById, getMasterData, getSoapAction, saveEncounterSigns, savePatientSoapAction, updateServiceCodeBlockedUnits, getPreviousSessionNotesDetails, saveClockInTimeIntoAppointment, saveClockOutTimeIntoAppointment } from './actions/soapActions';
import { getPatientProfileDetails } from '../../../patients/actions/PatientActions';
import React, { Component } from 'react';
import { renderCheckBox, renderTimePicker, renderTextField, renderTextArea, isValidNameWithSpace } from '../../../../components/reduxFields';
import { CancelButton, CommonButton } from '../../../../components/buttons';
import { getAppConfigList, getGeoLocation, getGeoLocationClockIn, getGeoLocationClockOut } from '../../../AppConfig/actions';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import classNames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';
import PatientInfo from '../../../patients/patient_info';
import ProblemModal from './soap_daignosisModal';
import CPTModal from './soap_CPTModal';
import SignatureWithRenderingProviderModal from './signatureWithRenderingProvider_modal';
import Alert from 'react-s-alert';


const validateTargetBehaviorsForReduction = (value) => !(value ? value.trim() : value) ? 'Please enter target behaviors for reduction.' : undefined;
const validateTargetBehaviorsForIncrease = (value) => !(value ? value.trim() : value) ? 'Please enter replacement skills for increase.' : undefined;
const validateNoEquipmentUtilized = (value) => !(value ? value.trim() : value) ? 'Please enter equipment utilized.' : undefined;
const validateSuppliesUtilized = (value) => !(value ? value.trim() : value) ? 'Please enter supplies utilized.' : undefined;
const validateBehaviorIncidents = (value) => !(value ? value.trim() : value) ? 'Please enter behavior incidents.' : undefined;
const validateSkillAcquisition = (value) => !(value ? value.trim() : value) ? 'Please enter skill acquisition.' : undefined;

const validateCommunication = (value) => !(value ? value.trim() : value) ? 'Please enter communication.' : undefined;
const validateAdaptive = (value) => !(value ? value.trim() : value) ? 'Please enter adaptive.' : undefined;
//const validateBehaviorReplacementSkills = (value) => !(value ? value.trim() : value) ? 'Please enter behavior replacement skills.' : undefined;
const validateChoicesOffered = (value) => !(value ? value.trim() : value) ? 'Please enter choices offered.' : undefined;

const validateCaregiverInvolvement = (value) => !(value ? value.trim() : value) ? 'Please enter caregiver involvement.' : undefined;
const validateCaregiverHomework = (value) => !(value ? value.trim() : value) ? 'Please enter caregiver homework.' : undefined;
const validateFollowUpCaregiverHomework = (value) => !(value ? value.trim() : value) ? 'Please enter follow up caregiver homework' : undefined;
const validateChangesToClientStatus = (value) => !(value ? value.trim() : value) ? 'Please enter changes to client status.' : undefined;



const validate = (values) => {
  const errors = {};  
  if (!values.OtherTrainingAddressedNotes) {
    errors.OtherTrainingAddressedNotes = 'Please enter other notes';
  }
  
  return errors;
};

class SessionNotes_RBT_TFABA extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      fixedHeader: true,
      height: '200px',
      selectable: false,
      fixedFooter: false,
      DateTimeOfVisit: '',
      patientObj: [],
      master_data: props.master_data,
      firstName: '',
      middleName: '',
      lastName: '',
      fullName: '',
      patient_id: null,
      apptid: parseInt(props.match.params.apptId, 10),
      encounterId: parseInt(props.match.params.encId, 10),
      isAdminUpdateAfterRendered: parseInt(props.match.params.isAdminUpdate, 10),
      isGenerateClaimAfterRendered: parseInt(props.match.params.isGenerateClaim, 10),
      staffID: null,
      renderingProviderID: null,
      renderingProviderName: '',
      appointmentDate: '',
      appointmentTime: '',
      staffName: '',
      patientName: '',
      appointmentTypeName: '',
      appointmentTypeIsBillable: false,
      serviceFacility: '',
      isDirectService: false,
      genderID: null,
      diagnosisArray: [],
      PatientLocationID: null,
      PatientLocationName: '',
      open: false,
      openCPT: false,
      openSign: false,
      soapPage: false,
      attachment: [],
      icdArray: [],
      DateOfService: '',
      master_CPT: props.master_data.masterCPT ? props.master_data.masterCPT : [],
      attachedDiagnosisArray: [],
      get_soap: null,
      serviceStartTime: '',
      serviceEndTime: '',
      appointment: null,
      ParentAppointmentID: null,
      appointmentStartDateTime: '',
      appointmentEndDateTime: '',
      CPTTableData: [],
      EmployeeSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      RenderingProviderSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      signRequired: {
        employee_sign: false,
        client_sign: false,
        guardian_sign: false,
        rederingProvider_sign: false,
      },
      showCompleteButton: false,
      isAllSigned: false,
      isSoapCompleted: false,
      signatureStaffs: [],
      signatureRenderingProviders: [],
      timeDifference: 0.0,      
      targetCaseManager: '',
      medicaidId: '',     
      leadAnalystMedicaidId: '',     
      behaviorTechnicianMedicaidId: '',     
      // isAdminUpdateAfterRendered: false,

      // checkbox handling
      isTrainingAddressedCheckAllowed: true,
      appointmentTypeID: null,
      clockInDateTime: '',
      clockOutDateTime: '',
      
    });
    this.filter = {
      isClientSigned: false,
      isEmployeeSigned: false,
      isGuardianSigned: false,
      isRenderingProviderSigned: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.renderDiagnosis = this.renderDiagnosis.bind(this);
    this.renderCpt = this.renderCpt.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCompleteSoap = this.onCompleteSoap.bind(this);    
    this.handleClockIn = this.handleClockIn.bind(this);
    this.handleClockOut = this.handleClockOut.bind(this);
  };

  componentWillMount() {
    this.props.getMasterData();
    // this.props.getPatientDetailsById(this.state.patient_id);
    if (this.state.apptid) {
      // this.props.getAppointmentById(this.state.apptid);
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }
    this.props.getAppConfigList();
  }

  handleCancel() {
    history.push('/scheduling');
  }

  handleAlertClick = (event) => {
    this.setState({clockInDateTime : moment.utc().format('YYYY-MM-DDTHH:mm:ss')},()=>{ this.props.getGeoLocationClockIn(); });    
    Alert.closeAll();
  };

  handleClockIn = (event) => {
    let warningMsg = 'Are you sure you want to clock-in ? You can only do it once. You should be at the location where session is taking place';
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick       
      },
    });
  };

  handleClockOutAlertClick = (event) => {
    this.setState({clockOutDateTime : moment.utc().format('YYYY-MM-DDTHH:mm:ss')},()=>{ this.props.getGeoLocationClockOut(); });    
    Alert.closeAll();
  };

  handleClockOut = (event) => {
    let warningMsg = 'Are you sure you want to clock-out ? You can only do it once. You should be at the location where session is taking place';
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleClockOutAlertClick       
      },
    });
  };

  formatedSoapData(soapDetail) {
    if (soapDetail) {
      let soapObj = soapDetail.data;
      // bind appointment data .....
      let appointmentData = soapObj.patientAppointment;
      let staffIds = [];
      let staffNames = [];
      let signatureStaffs = [];
      let medicaidIds = [];
      let leadAnalystMedicaidIds = [];
      let behaviorTechnicianMedicaidIds = [];
      appointmentData.appointmentSingleStaff.forEach((staff) => {
        staffNames.push(staff.staffName);
        staffIds.push(staff.staffId);
        signatureStaffs.push({ 'id': staff.staffId, 'value': staff.staffName });
        medicaidIds.push(staff.medicaidId);
        leadAnalystMedicaidIds.push(staff.leadAnalystMedicaidId);
        behaviorTechnicianMedicaidIds.push(staff.behaviorTechnicianMedicaidId);
      });

      let renderingProviderIds = [];
      let renderingProviderNames = [];
      let signatureRenderingProviders = [];      

      appointmentData.appointmentRenderingProviders.forEach((staff) => {
        renderingProviderNames.push(staff.renderingProviderName);
        renderingProviderIds.push(staff.renderingProviderId);
        signatureRenderingProviders.push({ 'id': staff.renderingProviderId, 'value': staff.renderingProviderName });
      });

      let staffID = staffIds && staffIds.length ? staffIds[0] : null;
      let staffName = staffNames && staffNames ? staffNames.join(',') : '';
      let renderingProviderID = renderingProviderIds && renderingProviderIds.length ? renderingProviderIds[0] : null;
      let renderingProviderName = renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '';
      let appointmentTypeName = appointmentData.appointmentTypeName;
      let appointmentTypeID = appointmentData.appointmentTypeID;
      let appointmentTypeIsBillable = appointmentData.isBillable;
      let appointmentDate = showFormatedDate(appointmentData.dateOfService);
      let appointmentTime = showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime);
      let patientName = appointmentData.patientName;
      // let appointmentTime = `${formattedStartTimehours}:${appointmentData.StartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${appointmentData.EndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      let PatientLocationID = '';
      let PatientLocationName = appointmentData.address;
      let medicaidId = medicaidIds && medicaidIds ? medicaidIds.join(',') : '';
      let leadAnalystMedicaidId = leadAnalystMedicaidIds && leadAnalystMedicaidIds ? leadAnalystMedicaidIds.join(',') : '';
      let behaviorTechnicianMedicaidId = behaviorTechnicianMedicaidIds && behaviorTechnicianMedicaidIds ? behaviorTechnicianMedicaidIds.join(',') : '';
      if (!appointmentTypeIsBillable) {
        this.setState({ isAllSigned: true });
      }
      // to get the patient info panel ..
      if (appointmentData.patientID) {
        this.props.getPatientProfileDetails(appointmentData.patientID);
      }

      this.setState({
        appointment: appointmentData,
        ParentAppointmentID: appointmentData.parentAppointmentId,
        staffID: staffID,
        staffName: staffName,
        renderingProviderID: renderingProviderID,        
        renderingProviderName: renderingProviderName,
        patient_id: appointmentData.patientID,
        patientName: patientName,
        appointmentTypeName: appointmentTypeName,
        appointmentTypeID: appointmentTypeID,
        appointmentTypeIsBillable: appointmentTypeIsBillable,
        appointmentDate: appointmentDate,
        appointmentTime: appointmentTime,
        DateTimeOfVisit: `${appointmentDate}, ${appointmentTime}`,
        PatientLocationName: PatientLocationName,
        PatientLocationID: PatientLocationID,
        DateOfService: appointmentData.startDateTime,
        appointmentStartDateTime: appointmentData.startDateTime,
        appointmentEndDateTime: appointmentData.endDateTime,
        serviceStartTime: appointmentData.startDateTime,
        serviceEndTime: appointmentData.endDateTime,
        showCompleteButton: appointmentTypeIsBillable && this.state.encounterId ? true : false,
        signatureStaffs: signatureStaffs,
        signatureRenderingProviders: signatureRenderingProviders,
        serviceFacility: appointmentData.serviceFacility,
        isDirectService: appointmentData.isDirectService,
        isAdminUpdateAfterRendered: (appointmentData.claimId && appointmentData.canEdit),
        clockInDateTime: appointmentData.clockInDateTime,
        clockOutDateTime: appointmentData.clockOutDateTime,
        timeDifference: appointmentData.timeDifference,        
        targetCaseManager: appointmentData.targetCaseManager,     
        medicaidId: medicaidId,     
        leadAnalystMedicaidId: leadAnalystMedicaidId,     
        behaviorTechnicianMedicaidId: behaviorTechnicianMedicaidId,     
      }, () => {
        if (soapObj.id && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
          // this.setState({
          //   serviceStartTime: soapObj.startDateTime,
          //   serviceEndTime: soapObj.endDateTime,
          // });
        }
        let icdArray = [];
        if (soapObj.patientEncounterDiagnosisCodes && soapObj.patientEncounterDiagnosisCodes.length) {
          soapObj.patientEncounterDiagnosisCodes.forEach((obj, index) => {
            icdArray.push({
              'DiagnosisDate': moment(obj.diagnosisDate).format(),
              'Description': obj.description,
              'ICDCodeId': obj.icdCodeId,
              'ICDCode': obj.icdCode,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
            });
          });
          this.setState({
            diagnosisArray: icdArray,
          });
        }
        let cptArray = [];
        if (soapObj.patientEncounterServiceCodes && soapObj.patientEncounterServiceCodes.length) {
          soapObj.patientEncounterServiceCodes.forEach((obj, index) => {
            cptArray.push({
              'AuthProcedureCPTLinkId': obj.authProcedureCPTLinkId,
              'AuthorizationNumber': obj.authorizationNumber,
              'ServiceCodeId': obj.serviceCodeId,
              'ServiceCode': obj.serviceCode,
              'Description': obj.description,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
              'Modifier1': obj.modifier1,
              'Modifier2': obj.modifier2,
              'Modifier3': obj.modifier3,
              'Modifier4': obj.modifier4,
              'AttachedModifiers': obj.attachedModifiers,
            });
          });
        }
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isGuardianSigned = true;
              this.setState({ GuardianSign: data });
            }
            if (signObj.patientSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: this.state.patientName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isClientSigned = true;
              this.setState({ ClientSign: data });
            }
            if (signObj.clinicianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: this.state.staffName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isEmployeeSigned = true;
              this.setState({ EmployeeSign: data });
            }
            if (signObj.renderingProviderSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.renderingProviderSign,
                Date: signObj.renderingProviderSignDate,
                //Name: this.state.renderingProviderName,
                Name: signObj.renderingProviderName ? signObj.renderingProviderName : this.state.renderingProviderName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              this.filter.isRenderingProviderSigned = true;
              this.setState({ RenderingProviderSign: data });
            }            
          });
        }
        if ((soapObj.status || '').toLowerCase() === 'rendered') {
          if (this.state.isAdminUpdateAfterRendered !== undefined && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
            this.setState({ isSoapCompleted: true, isAllSigned: true });
          } else {
            this.setState({ isAllSigned: true });
          }
        }
        if (!this.filter.isGuardianSigned) {
          let employee_signRequired = this.state.signRequired.employee_sign,
            client_signRequired = this.state.signRequired.client_sign,
            guardian_signRequired = this.state.signRequired.guardian_sign,
            rederingProvider_signRequired = this.state.signRequired.rederingProvider_sign;
          if (appointmentData && !appointmentData.isDirectService && this.state.signRequired.guardian_sign) {
            guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
          }

          this.setState({
            signRequired: {
              employee_sign: employee_signRequired,
              client_sign: client_signRequired,
              guardian_sign: guardian_signRequired,
              rederingProvider_sign: rederingProvider_signRequired,
            },
          }, () => {
            this.setState({
              isAllSigned: this.checkIsAllRequiredSigned(),
            });
          });
        }
        this.setState({
          isAllSigned: this.checkIsAllRequiredSigned(),
          get_soap: soapDetail.data,
          CPTTableData: cptArray,
          diagnosisArray: icdArray,
        },()=>{
          if(this.state.isGenerateClaimAfterRendered)
          {     
            var link = document.getElementById('btnComplete');      
            if(link)      
              link.click();            
          }
        });
      });
    }
  }
  componentWillReceiveProps(nextProps) {

    if (nextProps.match.params.encId !== this.props.match.params.encId) {
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,
        master_CPT: nextProps.master_data.masterCPT,
      });
    }
    if (nextProps.app_config && this.props.app_config !== nextProps.app_config) {
      let app_config = nextProps.app_config;
      let employee_signRequired = false;
      let client_signRequired = false;
      let guardian_signRequired = false;
      let rederingProvider_signRequired = false;
      if (app_config && app_config.length) {
        app_config.forEach((Obj) => {
          if (Obj.configType === 1) {
            switch (Obj.key) {
            case 'CLINICIAN_SIGN':
              employee_signRequired = (Obj.value.toString().toLowerCase() === 'true');
              break;
            case 'PATIENT_SIGN':
              client_signRequired = (Obj.value.toString().toLowerCase() === 'true');
              break;
            case 'GUARDIAN_SIGN':
              guardian_signRequired = (Obj.value.toString().toLowerCase() === 'true');
              break;
            case 'RENDERINGPROVIDER_SIGN':
              rederingProvider_signRequired = (Obj.value.toString().toLowerCase() === 'true');
              break;
            default:
              break;
            }
          }
        });
      }

      if (!this.filter.isGuardianSigned) {
        // let isAnySignRequired = employee_signRequired || client_signRequired || guardian_signRequired;
        let patientAppointmentData = this.state.get_soap && this.state.get_soap.patientAppointment;
        // let isAppointmentRendered = this.state.get_soap && (this.state.get_soap.status || '').toLowerCase() === 'rendered';
        if (patientAppointmentData && !patientAppointmentData.isDirectService && guardian_signRequired) {
          guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
        }
        this.setState({
          // isAllSigned: !isAnySignRequired,
          signRequired: {
            employee_sign: employee_signRequired,
            client_sign: client_signRequired,
            guardian_sign: guardian_signRequired,
            rederingProvider_sign: rederingProvider_signRequired,
          },
        }, () => {
          this.setState({
            isAllSigned: this.checkIsAllRequiredSigned(),
          });
        });
      }
    }

    if (nextProps.saved_soap && this.props.saved_soap !== nextProps.saved_soap) {
      if (nextProps.saved_soap.id) {
        if (!this.state.encounterId) {
          history.push(`/session-notes-rbt-tfaba/${this.state.apptid}/${nextProps.saved_soap.id}/${this.state.isAdminUpdateAfterRendered ? 1 : 0}/0`);
        } else {
          this.setState({ isSoapCompleted: true });
        }
        this.setState({ encounterId: nextProps.saved_soap.id, showCompleteButton: this.state.appointmentTypeIsBillable ? true : false });
      }
    }
    if (nextProps.get_soap && this.props.get_soap !== nextProps.get_soap) {
      this.formatedSoapData(nextProps.get_soap);
    }

    if (nextProps.saved_EncounterSigns && nextProps.saved_EncounterSigns !== this.props.saved_EncounterSigns) {
      let signObj = nextProps.saved_EncounterSigns.data;
      if (signObj.guardianSign) {
        let data = this.state.GuardianSign;
        data.id = signObj.id;
        this.setState({ GuardianSign: data });
      }
      if (signObj.patientSign) {
        let data = this.state.ClientSign;
        data.id = signObj.id;
        this.setState({ ClientSign: data });
      }
      if (signObj.clinicianSign) {
        let data = this.state.EmployeeSign;
        data.id = signObj.id;
        this.setState({ EmployeeSign: data });
      }
      if (signObj.renderingProviderSign) {
        let data = this.state.RenderingProviderSign;
        data.id = signObj.id;
        this.setState({ RenderingProviderSign: data });
      }
    }

    if (nextProps.clockInLatitude && nextProps.clockInLatitude > 0 && this.props.clockInLatitude !== nextProps.clockInLatitude) {
      let formData = {
        'appointmentId': this.state.apptid,
        'clockInDateTime': this.state.clockInDateTime,
        'clockInLatitude' : nextProps.clockInLatitude || 0.0,
        'clockInLongitude' : nextProps.clockInLongitude || 0.0,
      }
      this.props.saveClockInTimeIntoAppointment(formData);
    }

    if (nextProps.clockOutLatitude && nextProps.clockOutLatitude > 0 && this.props.clockOutLatitude !== nextProps.clockOutLatitude) {
      let formData = {
        'appointmentId': this.state.apptid,
        'clockOutDateTime': this.state.clockOutDateTime,
        'clockOutLatitude' : nextProps.clockOutLatitude || 0.0,
        'clockOutLongitude' : nextProps.clockOutLongitude || 0.0,
      }     
      this.props.saveClockOutTimeIntoAppointment(formData);
    }

  };

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  };

  onCompleteSoap(formProps) {
    this.setState({ isGenerateClaimAfterRendered: false });
    let isGenerateClaim = true;
    this.submitFormData(formProps, isGenerateClaim);
  }

  onSubmit(formProps) {
    this.submitFormData(formProps);
  };

  submitFormData(formProps, isGenerateClaim = false) {
    if (!this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length) {
      Alert.warning('Please add atleast one diagnosis!', {
        position: 'bottom-right',
        effect: 'slide',
      });
      return false;
    }
    if (this.state.appointmentTypeIsBillable) {
      if (!this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length) {
        Alert.warning('Please add atleast one service code!', {
          position: 'bottom-right',
          effect: 'slide',
        });
        return false;
      }
    }

    let ICDArray = this.state.diagnosisArray;
    let CPTcodes = this.state.CPTTableData;
    let formData = {
      'Id': this.state.encounterId,
      'PatientID': this.state.patient_id,
      'AppointmentStartDateTime': this.state.appointmentStartDateTime,
      'AppointmentEndDateTime': this.state.appointmentEndDateTime,
      'PatientAppointmentId': this.state.encounterId || !this.state.appointment.RecurrenceRule ? this.state.apptid : null,
      'ParentAppointmentId': this.state.encounterId ? null : this.state.ParentAppointmentID,
      'DateOfService': this.state.DateOfService,
      'StartDateTime': moment(this.state.serviceStartTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceStartTime).format('HH:mm:ss'),
      'EndDateTime': moment(this.state.serviceEndTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceEndTime).format('HH:mm:ss'),
      'StaffID': this.state.staffID,
      // 'LocationID': this.props.singleEncounter.locationID,
      'ServiceLocationID': this.state.appointment ? this.state.appointment.serviceLocationID : null,
      'OfficeAddressID': this.state.appointment ? this.state.appointment.officeAddressID : null,
      'PatientAddressID': this.state.appointment ? this.state.appointment.patientAddressID : null,
      'CustomAddressID': this.state.appointment ? this.state.appointment.customAddressID : null,
      'CustomAddress': this.state.appointment ? this.state.appointment.customAddress : null,
      'ServiceAddress': this.state.appointment ? this.state.appointment.address : null,
      // 'PatientSign': this.state.ClientSign.Bytes,
      // 'PatientSignDate': this.state.ClientSign.Date,
      // 'ClinicianSign': this.state.EmployeeSign.Bytes,
      // 'ClinicianSignDate': this.state.EmployeeSign.Date,
      // 'GuardianSign': this.state.GuardianSign.Bytes,
      // 'GuardianSignDate': this.state.GuardianSign.Date,
      // 'GuardianName': this.state.GuardianSign.Name,
      'NotetypeId': 2,
      'SessionNotes_RBT_TFABA': {
        'Id': this.state.get_soap && this.state.get_soap.sessionNotes_RBT_TFABA ? this.state.get_soap.sessionNotes_RBT_TFABA.id : 0,
        'TargetBehaviorsForReduction': formProps.TargetBehaviorsForReduction ? formProps.TargetBehaviorsForReduction.trim() : '',
        'TargetBehaviorsForIncrease': formProps.TargetBehaviorsForIncrease ? formProps.TargetBehaviorsForIncrease.trim() : '',
        'NoEquipmentUtilized': formProps.NoEquipmentUtilized ? formProps.NoEquipmentUtilized.trim() : '',
        'SuppliesUtilized': formProps.SuppliesUtilized ? formProps.SuppliesUtilized.trim() : '',
        'BehaviorIncidents': formProps.BehaviorIncidents ? formProps.BehaviorIncidents.trim() : '',       
        'SkillAcquisition': formProps.SkillAcquisition.trim(),
        'Communication': formProps.Communication.trim(),
        'Adaptive': formProps.Adaptive.trim(),
        //'BehaviorReplacementSkills': formProps.BehaviorReplacementSkills.trim(),
        'ChoicesOffered': formProps.ChoicesOffered.trim(),
        'CaregiverInvolvement': formProps.CaregiverInvolvement.trim(),
        'CaregiverHomework': formProps.CaregiverHomework.trim(),
        'FollowUpCaregiverHomework': formProps.FollowUpCaregiverHomework.trim(),
        'ChangesToClientStatus': formProps.ChangesToClientStatus.trim(),
        //'TargetCaseManager': '',

        'TFABA_RBT_TrainingAddressed': [{
          'TrainingAddressedSessionId': this.state.get_soap && this.state.get_soap.sessionNotes_RBT_TFABA && this.state.get_soap.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed ? this.state.get_soap.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed.id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_RBT_TFABA ? this.state.get_soap.sessionNotes_RBT_TFABA.id : 0,
          'Consistency': formProps.Consistency || 0,
          'ChoiceMaking': formProps.ChoiceMaking || 0,
          'InterventionPlan': formProps.InterventionPlan || 0,
          'AutonomyInformation': formProps.AutonomyInformation || 0,
          'JunkBehavior': formProps.JunkBehavior || 0,
          'CommunityIntegration': formProps.CommunityIntegration || 0,
          'Reinforcement': formProps.Reinforcement || 0,
          'Confidentiality': formProps.Confidentiality || 0,
          'FunctionalCommunication': formProps.FunctionalCommunication || 0,

          'FreeFromAbuseAndNeglect': formProps.FreeFromAbuseAndNeglect || 0,
          'SettingExpectations': formProps.SettingExpectations || 0,
          'ConsumerPreferences': formProps.ConsumerPreferences || 0,
          'RoleModeling': formProps.RoleModeling || 0,
          'SafeAndSafeGuards': formProps.SafeAndSafeGuards || 0,
          'Monitoring': formProps.Monitoring || 0,
          'IndividualRights': formProps.IndividualRights || 0,
          'TaskAnalysis': formProps.TaskAnalysis || 0,
          'HealthAndWellness': formProps.HealthAndWellness || 0,

          'Feedback': formProps.Feedback || 0,
          'ReviewClientChoice': formProps.ReviewClientChoice || 0,
          'ObservationalAssessment': formProps.ObservationalAssessment || 0,
          'Relaxation': formProps.Relaxation || 0,

          'OtherTrainingAddressed': formProps.OtherTrainingAddressed || 0,
          'OtherTrainingAddressedNotes': formProps.OtherTrainingAddressed ? formProps.OtherTrainingAddressedNotes : '',
        }]
          
      },
      'PatientEncounterServiceCodes': CPTcodes,
      'PatientEncounterDiagnosisCodes': ICDArray,
      'isBillableEncounter': this.state.appointmentTypeIsBillable ? true : false,
    };
    // console.log('submit data =========',formData);
    let trainingAddressedCheckPermission = false;
    

    // Check directly formData
    if(formData.SessionNotes_RBT_TFABA.TFABA_RBT_TrainingAddressed) {
        let trainingAddressedCheck = formData.SessionNotes_RBT_TFABA.TFABA_RBT_TrainingAddressed[0];
        var count = 0;
        // For Training Addressed
        if(trainingAddressedCheck.Consistency === true)
          count = count + 1;
        if(trainingAddressedCheck.ChoiceMaking === true)
          count = count + 1;
        if(trainingAddressedCheck.InterventionPlan === true)
            count = count + 1;
        if(trainingAddressedCheck.AutonomyInformation === true)
            count = count + 1;
        if(trainingAddressedCheck.JunkBehavior === true)
            count = count + 1;
        if(trainingAddressedCheck.CommunityIntegration === true)
            count = count + 1;
        if(trainingAddressedCheck.Reinforcement === true)
            count = count + 1;
        if(trainingAddressedCheck.Confidentiality === true)
            count = count + 1;
        if(trainingAddressedCheck.FunctionalCommunication === true)
            count = count + 1;
        if(trainingAddressedCheck.FreeFromAbuseAndNeglect === true)
            count = count + 1;
        if(trainingAddressedCheck.SettingExpectations === true)
            count = count + 1;
        if(trainingAddressedCheck.ConsumerPreferences === true)
            count = count + 1;
        if(trainingAddressedCheck.RoleModeling === true)
            count = count + 1;
        if(trainingAddressedCheck.SafeAndSafeGuards === true)
            count = count + 1;
        if(trainingAddressedCheck.Monitoring === true)
            count = count + 1;
        if(trainingAddressedCheck.IndividualRights === true)
            count = count + 1;
        if(trainingAddressedCheck.TaskAnalysis === true)
            count = count + 1;
        if(trainingAddressedCheck.HealthAndWellness === true)
            count = count + 1;
        if(trainingAddressedCheck.Feedback === true)
            count = count + 1;
        if(trainingAddressedCheck.ReviewClientChoice === true)
            count = count + 1;
        if(trainingAddressedCheck.ObservationalAssessment === true)
            count = count + 1;
        if(trainingAddressedCheck.Relaxation === true)
            count = count + 1;
        if(trainingAddressedCheck.OtherTrainingAddressed === true)
            count = count + 1;

       if(count < 2) {
            trainingAddressedCheckPermission = false;
          this.setState({ isTrainingAddressedCheckAllowed: false });
        } else {
          trainingAddressedCheckPermission = true;
          this.setState({ isTrainingAddressedCheckAllowed: true });
        }

           
    }
  
    // check for user is Admin and Soap has been rendered ...
    let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission;
    if(trainingAddressedCheckPermission === true) {
      this.props.savePatientSoapAction(formData, isGenerateClaim, isAdminUpdateAfterRendered);
    } else {
      Alert.error('Please fill training addressed details!', {
        position: 'bottom-right',
        effect: 'slide',
      });
    }
  }

  

  handleOpen = () => {
    this.setState({ open: true, soapPage: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleOpenCPT = () => {
    this.setState({ openCPT: true, soapPage: true });
  };
  handleCloseCPT = () => {
    this.setState({ openCPT: false });
  };
  handleOpenSign = () => {
    this.props.getGeoLocation();
    this.setState({ openSign: true, soapPage: true });
  };
  handleCloseSign = () => {
    this.setState({ openSign: false });
  };
  DiagnosisAlertClick = (e, index) => {
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ diagnosisArray: arr });
    }
  }
  handleRemoveDiagnosisClick = (e, index) => {
    Alert.warning('Are you sure you want to remove this diagnosis?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.DiagnosisAlertClick,
        id: index,
      },
    });
  }
  CPTCodeAlertClick = (e, data) => {
    if (data.AuthProcedureCPTLinkId) {
      // let postData = {
      //   authProcedureCPTLinkId: data.AuthProcedureCPTLinkId,
      //   actionName: 'Delete',
      // };
      // this.props.updateServiceCodeBlockedUnits(postData);
    }
    let index = data.index;
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ CPTTableData: arr });
    }
  }
  handleRemoveCPTCodeClick = (e, data) => {
    Alert.warning('Are you sure you want to remove this service code?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.CPTCodeAlertClick,
        id: data,
      },
    });
  }
  renderDiagnosis() {
    if (this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).map((diagnosis, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="30%">{diagnosis.ICDCode}</TableRowColumn>
          <TableRowColumn width="70%">{diagnosis.Description ? diagnosis.Description : '-'}</TableRowColumn>
          {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
            <TableRowColumn><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button></TableRowColumn>
            : null} */}
        </TableRow>
      );
    });
  }
  renderCpt() {
    if (this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).map((cpt, index) => {
      // let data = {
      //   index: index,
      //   AuthProcedureCPTLinkId: cpt.AuthProcedureCPTLinkId,
      // };
      return (
        <TableRow key={index}>
          <TableRowColumn>{cpt.ServiceCode ? cpt.ServiceCode : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.AttachedModifiers ? cpt.AttachedModifiers : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.Description ? cpt.Description : '-'}</TableRowColumn>
          {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
            <td width="10%"><button onClick={(e) => this.handleRemoveCPTCodeClick(e, data)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button></td>
            : null} */}
        </TableRow>
      );
    });
  }

  handleAddDiagnosis = (formValues) => {
    let diseaseDetails = extractDataFromArray(this.state.master_data.masterICD, formValues.ICDID);
    let arr = this.state.diagnosisArray;
    if (arr.indexOf(formValues) === -1) {
      arr.push({
        'DiagnosisDate': moment(formValues.DiagnosisDate).format(),
        'Description': diseaseDetails.description,
        'ICDCodeId': diseaseDetails.id,
        'ICDCode': diseaseDetails.code,
        'IsDeleted': false,
        'Id': 0,
      });
      this.setState({ diagnosisArray: arr });
    }
  }
  handleAddCPT = (formValues) => {
    if (formValues.AuthProcedureCPTLinkId) {
      // let postData = {
      //   authProcedureCPTLinkId: formValues.AuthProcedureCPTLinkId,
      //   actionName: 'Add',
      // };
      // this.props.updateServiceCodeBlockedUnits(postData);
    }
    let cptObj = extractDataFromArray(this.state.master_data.masterServiceCode, formValues.CPTID);
    let arr = this.state.CPTTableData;
    if (arr.indexOf(cptObj) === -1) {
      arr.push({
        'AuthProcedureCPTLinkId': formValues.AuthProcedureCPTLinkId,
        'AuthorizationNumber': formValues.AuthorizationNumber,
        'ServiceCodeId': cptObj.id,
        'ServiceCode': cptObj.serviceCode,
        'Description': cptObj.description,
        'IsDeleted': false,
        'Id': 0,
        'Modifier1': formValues.Modifier1 ? formValues.Modifier1 : null,
        'Modifier2': formValues.Modifier2 ? formValues.Modifier2 : null,
        'Modifier3': formValues.Modifier3 ? formValues.Modifier3 : null,
        'Modifier4': formValues.Modifier4 ? formValues.Modifier4 : null,
      });
      this.setState({ CPTTableData: arr });
    }
  }
  handleAddSign = (formProps) => {

    let signBytes = formProps.signBytes.substring(22);
    let data = {
      Bytes: signBytes,
      Date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      Name: '',
      Latitude: 0.0,
      Longitude: 0.0,
    };
    switch (formProps.Signee) {
      case 1:
        data.id = this.state.EmployeeSign.id || null;
        data.Name = extractNameFromArray(this.state.signatureStaffs, formProps.StaffID);
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ EmployeeSign: data });
        this.filter.isEmployeeSigned = true;
        this.saveEncounterSigns(data.id, data, null, null, null);
        break;
      case 2:
        data.id = this.state.ClientSign.id || null;
        data.Name = this.state.patientName;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ ClientSign: data });
        this.filter.isClientSigned = true;
        this.saveEncounterSigns(data.id, null, data, null, null);
        break;
      case 3:
        data.id = this.state.GuardianSign.id || null;
        data.Name = formProps.Guardian;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ GuardianSign: data });
        this.filter.isGuardianSigned = true;
        this.saveEncounterSigns(data.id, null, null, data, null);
        break;
      case 4:
        data.id = this.state.RenderingProviderSign.id || null;
        data.Name = extractNameFromArray(this.state.signatureRenderingProviders, formProps.RenderingProviderID);
        //data.Name = formProps.SupervisingClinician;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ RenderingProviderSign: data });
        this.filter.isRenderingProviderSigned = true;
        this.saveEncounterSigns(data.id, null, null, null, data);
        break;
      default:
        break;
    }

    this.setState({ isAllSigned: this.checkIsAllRequiredSigned() });
  }

  checkIsAllRequiredSigned() {
    let employee_Signed = true, client_signed = true, guardian_signed = true, rederingProvider_signed = true;
    if (this.state.signRequired.employee_sign) {
      if (this.filter.isEmployeeSigned) {
        employee_Signed = true;
      } else {
        employee_Signed = false;
      }
    }
    if (this.state.signRequired.client_sign) {
      if (this.filter.isClientSigned) {
        client_signed = true;
      } else {
        client_signed = false;
      }
    }
    if (this.state.signRequired.guardian_sign) {
      if (this.filter.isGuardianSigned) {
        guardian_signed = true;
      } else {
        guardian_signed = false;
      }
    }
    if (this.state.signRequired.rederingProvider_sign) {
      if (this.filter.isRenderingProviderSigned) {
        rederingProvider_signed = true;
      } else {
        rederingProvider_signed = false;
      }
    }
    
    // finally check if all required are signed ...
    if (employee_Signed && client_signed && guardian_signed && rederingProvider_signed) {
      return true;
    } else {
      return false;
    }
  }

  handleGetSessionNoteDetailsFromLastSessionCheck = (input, name) => {
    if(input.target.checked)
    {
      this.props.getPreviousSessionNotesDetails(this.state.apptid, this.state.appointmentTypeID, this.state.patient_id, this.state.staffID, 2);

    }
  }

  saveEncounterSigns(id = 0, employeeSign, patientSign, guradianSign, renderingProviderSign) {
    let postData = {
      id: id,
      patientEncounterId: this.state.encounterId,
      patientId: patientSign ? this.state.patient_id : null,
      patientSign: patientSign ? patientSign.Bytes : null,
      patientSignDate: patientSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      staffId: employeeSign ? this.state.staffID : null,
      clinicianSign: employeeSign ? employeeSign.Bytes : null,
      clinicianSignDate: employeeSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      guardianName: guradianSign ? guradianSign.Name : null,
      guardianSign: guradianSign ? guradianSign.Bytes : null,
      guardianSignDate: guradianSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      staffId: renderingProviderSign ? this.state.renderingProviderID : null,
      //renderingProviderName: renderingProviderSign ? renderingProviderSign.Name : null,
      renderingProviderSign: renderingProviderSign ? renderingProviderSign.Bytes : null,
      renderingProviderSignDate: renderingProviderSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      latitude: this.props.latitude ? this.props.latitude : 0.0,
      longitude: this.props.longitude ? this.props.longitude : 0.0,
    };
    // console.log(JSON.stringify(postData));
    this.props.saveEncounterSigns(postData);
  }

  // componentDidUpdate() {
  //   if(this.state.isGenerateClaimAfterRendered)
  //   {     
  //     var link = document.getElementById('btnComplete');      
  //     if(link)      
  //       link.click();            
  //   }    
  // }
  
  render() {
    const { handleSubmit } = this.props;
    // const tableClass = classNames({
    //   'table': true,
    //   'table-striped': this.props.bordered,
    //   'table-bordered': this.props.bordered,
    //   'table-hover': true,
    //   'table-condensed': this.props.condensed,
    //   'customtable': true,
    // });
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });
    let totalUnitsConsumed = (this.state.get_soap && this.state.get_soap.unitsConsumed) || 0;
    let canOnlyAddSignForTheirNotes = true;
    if (this.props.canOnlyAddSignForTheirNotes && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
      canOnlyAddSignForTheirNotes = this.props.currentLoginUserId === this.state.staffID;
    }
    return (
      <div>
        <h2 className="page_title">Visit Details</h2>
        {this.state.patient_id ?
          <PatientInfo patientId={this.state.patient_id} />
          : ''}
        {this.state.open ?
          <ProblemModal soapPage={this.state.soapPage} diagnosisArray={this.state.diagnosisArray} master_data={this.state.master_data} closeDialog={this.handleClose} handleAddDiagnosis={this.handleAddDiagnosis} />
          : null}
        {this.state.openCPT ?
          <CPTModal soapPage={this.state.soapPage} patientId={this.state.patient_id} dateOfService={this.state.DateOfService} cptArray={this.state.CPTTableData} master_CPT={this.state.master_data.masterServiceCode ? this.state.master_data.masterServiceCode : this.props.master_data.masterServiceCode} closeDialog={this.handleCloseCPT} handleAddCPT={this.handleAddCPT} />
          : null}
        {this.state.openSign ?
          <SignatureWithRenderingProviderModal staffID={this.state.staffID} renderingProviderID={this.state.renderingProviderID} clientName={this.state.patientName} staffs={this.state.signatureStaffs} renderingProviders={this.state.signatureRenderingProviders} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />
          : null}
        <div className="clearfix"></div>
        <div className="readmin-panel mt-15">
          <div className="panel-body">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <div className="row">
                  <div className="col-8 col-sm-8 col-md-8">
                    {this.state.isGenerateClaimAfterRendered ?
                      <div className={'alert alert-danger-soap update-pwd'}>
                          <strong>**YOU MUST SCROLL DOWN AND CLICK ON THE COMPLETE BUTTON TO SAVE YOUR CHANGES. <br/> CHANGES MAY NOT BE SAVED UNLESS YOU CLICK COMPLETE! <br/> IF THERE IS NO COMPLETE BUTTON THEN YOUR CHANGES HAVE BEEN SAVED AUTOMATICALLY. **</strong>
                      </div>
                      : 
                      <CommonButton className="mb-20" label="Go back to scheduler" primary={true} onTouchTap={this.handleCancel} />
                    } 
                  </div>
                <div className="col-2 col-sm-2 col-md-2 btn_rt">                    
                      <CommonButton className="mb-20" label="Clock In" disabled={this.state.clockInDateTime ? true : false} primary={true} onTouchTap={this.handleClockIn} />                    
                </div>
                <div className="col-2 col-sm-2 col-md-2 btn_rt">                    
                      <CommonButton className="mb-20" label="Clock Out" disabled={this.state.clockOutDateTime ? true : false} primary={true} onTouchTap={this.handleClockOut} />                    
                </div>
                </div>
                <div className="row">
                  <div className="col-6 col-sm-6 col-md-6 mb-20">
                      <Field className="mt20 mb0 custm_check"
                            name="isGetSessionNoteDetailsFromLastSession"
                            label="Get Session Note details from last session"
                            disabled={this.state.encounterId > 0 ? true : false}
                            onChange={(e) => this.handleGetSessionNoteDetailsFromLastSessionCheck(e, 'ActiveClient')}
                            component={renderCheckBox}
                          />
                  </div>
                  <div className="col-6 col-sm-6 col-md-6"></div>
                </div>
              <div className="row">                
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                      <p>
                        <b>Session Duration (In Mins):</b> <span>{this.state.timeDifference}</span>
                      </p>
                      <p>
                        <b>Targeted Case Manager:</b> <span>{this.state.targetCaseManager}</span>
                      </p>
                      <p>
                        <b>Medicaid ID:</b> <span>{this.state.medicaidId}</span>
                      </p>
                      <p>
                        <b>Lead Analyst Medicaid ID:</b> <span>{this.state.leadAnalystMedicaidId}</span>
                      </p>
                      <p>
                        <b>Behavior Technician Medicaid ID:</b> <span>{this.state.behaviorTechnicianMedicaidId}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    fullWidth={true}
                    // disabled={this.state.isSoapCompleted}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    // disabled={this.state.isSoapCompleted}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceEndTime}
                    onDateChange={this.onDateChange}
                    fullWidth={true}
                  />
                </div>
                {/* <div className='col-sm-6'>
                  <Field
                    name="TargetCaseManager"
                    type="text"
                    fullWidth={true}
                    label="Target Case Manager"                  
                    disabled={true}
                    component={renderTextField}                   
                  />   
                </div>  */}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>RBT Session Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="row">                
                <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="TargetBehaviorsForReduction"
                    type="text"
                    fullWidth={true}
                    label="Target Behaviors For Reduction"
                    // autoHeight={true}
                    rows={10}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateTargetBehaviorsForReduction] : null}
                  />
                </div>               
                <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="TargetBehaviorsForIncrease"
                    type="text"
                    fullWidth={true}
                    label="Replacement Skills for Increase"
                    // autoHeight={true}
                    rows={10}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}      
                    validate={this.state.appointmentTypeIsBillable === true ? [validateTargetBehaviorsForIncrease] : null}            
                  />
                </div>
              </div>
              <div className="row">
                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin require">
                    <h6><b>Behavior Analysis Service Delivery: </b>Under direct observation/training of BCBA, Registered Behavior Technician provided training to client, direct care supports and/or family, regarding implementation of all components of the BSP to include replacement skill procedures, decel procedures, antecedent/environmental manipulations, and data collection/documentation, through a combination of role-play, modeling, feedback and coaching in the home, community, and school settings.</h6>
                  </div>   
                  <div className="panel_title no_margin require mb-20">
                    <h6><b>See data sheets for specific programs implemented and data collected.</b></h6>
                  </div>                  
                </div>
              </div>
              <div className="row">                
                <div className="col-sm-3 mt-35">
                  ***Equipment utilized :
                </div>
                <div className="col-sm-9 require">                
                  <Field
                    //autoFocus={true}
                    name="NoEquipmentUtilized"
                    type="text"
                    maxLength="100"
                    normalize={isValidNameWithSpace}
                    label="Equipment Utilized"
                    component={renderTextField}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateNoEquipmentUtilized] : null}
                    />
                </div>
              </div>
              <div className="row">                
                <div className="col-sm-3 mt-35">
                  ***Supplies utilized: 
                </div>
                <div className="col-sm-6 require">                  
                  <Field
                    //autoFocus={true}
                    name="SuppliesUtilized"
                    type="text"
                    maxLength="100"
                    normalize={isValidNameWithSpace}
                    label="Supplies Utilized"
                    component={renderTextField} 
                    validate={this.state.appointmentTypeIsBillable === true ? [validateSuppliesUtilized] : null}
                    />                    
                </div>
                <div className="col-sm-3 mt-35">
                  <span> reinforcers (edibles, potables, tangibles)</span>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Training Addressed During Session</h5><span style={{ color: 'red'}}>*</span>
                    {!this.state.isTrainingAddressedCheckAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least two)</div>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Consistency"
                    label="Consistency - Caregiver/s"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ChoiceMaking"
                    label="Choices/Choice Making"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="InterventionPlan"
                    label="Intervention Plan"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AutonomyInformation"
                    label="Autonomy Information"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="JunkBehavior"
                    label="Junk Behavior"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="CommunityIntegration"
                    label="Affiliation/Community Integration"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>

                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Reinforcement"
                    label="Reinforcement"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Confidentiality"
                    label="Confidentiality"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FunctionalCommunication"
                    label="Functional Communication"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FreeFromAbuseAndNeglect"
                    label="Free from Abuse And Neglect"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SettingExpectations"
                    label="Setting Expectations w/ Client/Caregiver"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ConsumerPreferences"
                    label="Consumer Preferences/Dislikes"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="RoleModeling"
                    label="Role Modeling - CBA"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SafeAndSafeGuards"
                    label="Safe And Safeguards"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Monitoring"
                    label="Monitoring/Feedback - CBA"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IndividualRights"
                    label="Individual Rights And Fair Treatment"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TaskAnalysis"
                    label="Task Analysis/Data Entry"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="HealthAndWellness"
                    label="Health And Wellness"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Feedback"
                    label="Feedback - CBA"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ReviewClientChoice"
                    label="Review Clients Choice of Time, Date, and Place for Services Rendered"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObservationalAssessment"
                    label="Observational Assessment - CBA"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Relaxation"
                    label="Relaxation/Calming Skills - CBA"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTrainingAddressed"
                    label="Other: ABC Data Collection"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTrainingAddressed &&
                  (<div className='col-sm-4 require'>
                  <Field
                    name="OtherTrainingAddressedNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="BehaviorIncidents"
                    type="text"
                    fullWidth={true}
                    label="Behavior Incidents: Description of behaviors targeted for decrease/replacement skills utilized/interventions utilized:"
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateBehaviorIncidents] : null}
                  />
                </div>
                <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="SkillAcquisition"
                    type="text"
                    fullWidth={true}
                    label="Skill Acquisition"
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateSkillAcquisition] : null}
                  />
                </div>
                <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="Communication"
                    type="text"
                    fullWidth={true}
                    label="Communication"
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateCommunication] : null}
                  />
                </div>
                <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="Adaptive"
                    type="text"
                    fullWidth={true}
                    label="Adaptive"
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateAdaptive] : null}
                  />
                </div>
                {/* <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="BehaviorReplacementSkills"
                    type="text"
                    fullWidth={true}
                    label="Behavior Replacement Skills"
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateBehaviorReplacementSkills] : null}
                  />
                </div> */}
                <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="ChoicesOffered"
                    type="text"
                    fullWidth={true}
                    label="Choices Offered: Choices offered during session to client e.g. reinforcers, location of therapy, activities used for programming etc.: "
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateChoicesOffered] : null}
                  />
                </div>
                <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="CaregiverInvolvement"
                    type="text"
                    fullWidth={true}
                    label="Caregiver Involvement: Narrative of caregiver participation and feedback given to caregiver:"
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateCaregiverInvolvement] : null}
                  />
                </div>

                <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="CaregiverHomework"
                    type="text"
                    fullWidth={true}
                    label="Caregiver Homework"
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateCaregiverHomework] : null}
                  />
                </div>
                <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="FollowUpCaregiverHomework"
                    type="text"
                    fullWidth={true}
                    label="Follow Up Caregiver Homework"
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateFollowUpCaregiverHomework] : null}
                  />
                </div>
                <div className={this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} >
                  <Field
                    name="ChangesToClientStatus"
                    type="text"
                    fullWidth={true}
                    label="Changes to client status: List any changes to client’s mental, physical or medical status. Include changes with medication, living status, etc."
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                    validate={this.state.appointmentTypeIsBillable === true ? [validateChangesToClientStatus] : null}
                  />
                </div>
              </div>
            
            </form>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3>Diagnosis</h3>
                  <i className="flaticon flaticon-gym"></i>
                </div>
              </div>
              {/* {this.props.addPermission && !this.state.isSoapCompleted ?
                <div className="col-sm-12 pdl-30">
                  <CommonButton className="soapmodal_btn" label="Add Diagnosis" primary={true} onTouchTap={this.handleOpen} />
                </div>
                : null} */}
            </div>
            <div className="table-responsive mt-15">
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                    <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    {/* {!this.state.isSoapCompleted ?
                      <TableHeaderColumn>Action</TableHeaderColumn>
                      : null} */}
                    {/* <TableHeaderColumn width="20%">Attach</TableHeaderColumn>*/}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderDiagnosis()}
                </TableBody>
              </Table>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3>Service Codes</h3>
                  <i className="flaticon flaticon-interface-2"></i>
                </div>
              </div>
              {/* {this.props.addPermission && !this.state.isSoapCompleted ?
                <div className="col-sm-12 pdl-30">
                  <RaisedButton className="soapmodal_btn" label="Add Service Codes" primary={true} onTouchTap={this.handleOpenCPT} />
                </div>
                : null} */}
            </div>
            <div className="mt-15">
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn>Service Code</TableHeaderColumn>
                    <TableHeaderColumn>Modifiers</TableHeaderColumn>
                    <TableHeaderColumn>Description</TableHeaderColumn>
                    {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
                      <TableHeaderColumn width="10%">Action</TableHeaderColumn>
                      : null} */}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderCpt()}
                </TableBody>
              </Table>
            </div>
            <div className="row">
              <div className={`col-sm-12 pt20 btn_rt ${this.state.showCompleteButton && 'scroll_btn'}`}>
                <CancelButton onTouchTap={this.handleCancel} />
                {this.state.showCompleteButton && canOnlyAddSignForTheirNotes ?
                  <CommonButton className="soapmodal_btn ml-3" label="Add Sign" primary={true} onTouchTap={this.handleOpenSign} />
                  : ''}

                {!this.state.isSoapCompleted ?
                  (<span>
                    {this.state.showCompleteButton ?
                      <CommonButton id="btnComplete" className="ml-3 soapmodal_btn" label="Complete" primary={true} disabled={!this.state.isAllSigned} onClick={handleSubmit(this.onCompleteSoap)} />
                      : <CommonButton onClick={handleSubmit(this.onSubmit)} className="ml-3" primary={true} label="Save" />
                    }
                  </span>)
                  : ''}
              </div>
            </div>

            {this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes || this.state.RenderingProviderSign.Bytes ?
              <div className="row">
                <div className="col-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Signature</h3>
                    <i className="flaticon flaticon-medical-1"></i>
                  </div>
                </div>
                {
                  this.state.EmployeeSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                              <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name ? this.state.ClientSign.Name : this.state.patientName} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.RenderingProviderSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.RenderingProviderSign.Bytes}`} alt={''} />
                              <h3>{this.state.RenderingProviderSign.Name} <span>(Supervising Clinician)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.RenderingProviderSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.RenderingProviderSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.RenderingProviderSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
              </div>
              : ''}

          </div>
        </div>
      </div>
    );
  }
};
const selector = formValueSelector('soapForm');
SessionNotes_RBT_TFABA = reduxForm({
  form: 'soapForm',
  validate,
  enableReinitialize: true,
})(SessionNotes_RBT_TFABA);

function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'SCHEDULING');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'SCHEDULING_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_ADDCODES_IN_SOAP')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_DELETECODES_IN_SOAP')[0].permission : false;
  let modifyAfterRenderPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_MODIFYAPPOINTMENT_AFTER_RENDERING')[0].permission : false;
  let requiredGuardianSignForIndirectServicePermission = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_REQUIRED_GUARDIAN_SIGNATURE_FOR_INDIRECT_SERVICE')[0].permission : false;
  let canOnlyAddSignForTheirNotes = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_PRACTITIONER_CAN_ONLY_ADD_SIGN_FOR_THEIR_OWN_NOTES')[0].permission : false;
  // End For Role Permission

  let app_config = state.appConfig.appConfigList ? state.appConfig.appConfigList.data : null;
  let initialData = null;
  if (state.soap.get_soap) {
    let obj = state.soap.get_soap.data;
    if (obj.sessionNotes_RBT_TFABA) {
      initialData = {
        TargetBehaviorsForReduction: obj.sessionNotes_RBT_TFABA.targetBehaviorsForReduction,
        TargetBehaviorsForIncrease: obj.sessionNotes_RBT_TFABA.targetBehaviorsForIncrease,
        NoEquipmentUtilized: obj.sessionNotes_RBT_TFABA.noEquipmentUtilized,
        SuppliesUtilized: obj.sessionNotes_RBT_TFABA.suppliesUtilized,
        BehaviorIncidents: obj.sessionNotes_RBT_TFABA.behaviorIncidents,
        SkillAcquisition: obj.sessionNotes_RBT_TFABA.skillAcquisition,
        Communication: obj.sessionNotes_RBT_TFABA.communication,
        Adaptive: obj.sessionNotes_RBT_TFABA.adaptive,
        //BehaviorReplacementSkills: obj.sessionNotes_RBT_TFABA.behaviorReplacementSkills,
        ChoicesOffered: obj.sessionNotes_RBT_TFABA.choicesOffered,
        CaregiverInvolvement: obj.sessionNotes_RBT_TFABA.caregiverInvolvement,
        CaregiverHomework: obj.sessionNotes_RBT_TFABA.caregiverHomework,
        FollowUpCaregiverHomework: obj.sessionNotes_RBT_TFABA.followUpCaregiverHomework,
        ChangesToClientStatus: obj.sessionNotes_RBT_TFABA.changesToClientStatus,
        //TargetCaseManager: obj.sessionNotes_RBT_TFABA.targetCaseManager,

        // TFABA_RBT_TrainingAddressed
        Consistency: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].consistency,
        ChoiceMaking: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].choiceMaking,
        InterventionPlan: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].interventionPlan,
        AutonomyInformation: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].autonomyInformation,
        JunkBehavior: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].junkBehavior,
        CommunityIntegration: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].communityIntegration,
        Reinforcement: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].reinforcement,
        Confidentiality: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].confidentiality,
        FunctionalCommunication: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].functionalCommunication,
        FreeFromAbuseAndNeglect: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].freeFromAbuseAndNeglect,
        SettingExpectations: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].settingExpectations,
        ConsumerPreferences: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].consumerPreferences,
        RoleModeling: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].roleModeling,
        SafeAndSafeGuards: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].safeAndSafeGuards,
        Monitoring: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].monitoring,
        IndividualRights: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].individualRights,
        TaskAnalysis: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].taskAnalysis,
        HealthAndWellness: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].healthAndWellness,
        Feedback: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].feedback,
        ReviewClientChoice: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].reviewClientChoice,
        ObservationalAssessment: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].observationalAssessment,
        Relaxation: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].relaxation,
        OtherTrainingAddressed: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].otherTrainingAddressed,
        OtherTrainingAddressedNotes: obj.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].otherTrainingAddressedNotes,
      };
    }
  }


  if (state.soap.get_PreviousSessionNotesDetails) {
    let obj = state.soap.get_PreviousSessionNotesDetails.data;
    if (obj) {
      initialData = {      
        TargetBehaviorsForReduction: obj.targetBehaviorsForReduction,
        TargetBehaviorsForIncrease: obj.targetBehaviorsForIncrease,
        NoEquipmentUtilized: obj.noEquipmentUtilized,
        SuppliesUtilized: obj.suppliesUtilized,
        BehaviorIncidents: obj.behaviorIncidents,
        SkillAcquisition: obj.skillAcquisition,
        Communication: obj.communication,
        Adaptive: obj.adaptive,
        //BehaviorReplacementSkills: obj.behaviorReplacementSkills,
        ChoicesOffered: obj.choicesOffered,
        CaregiverInvolvement: obj.caregiverInvolvement,
        CaregiverHomework: obj.caregiverHomework,
        FollowUpCaregiverHomework: obj.followUpCaregiverHomework,
        ChangesToClientStatus: obj.changesToClientStatus,
      };
    }
  }

  return {
    selectorOtherTrainingAddressed: selector(state, 'OtherTrainingAddressed'),    
    
    app_config: app_config,
    userLocationList: state.login.userLocationList,
    master_data: state.soap.master_data,
    patientData: state.patient.get_patient_byid,
    patientPrimaryDiagnosis: state.patient.patientPrimaryDiagnosis,

    loading: state.soap.loading,
    appointment: state.soap.appointment,
    get_soap: state.soap.get_soap,
    saved_soap: state.soap.saved_soap && state.soap.saved_soap.data ? state.soap.saved_soap.data : null,
    initialValues: initialData,
    currentLoginUserId: state.login.loginUserInfo && state.login.loginUserInfo.id,
    hasDefaultAccess: hasDefaultAccess,
    addPermission: addPermission,
    deletePermission: deletePermission,
    modifyAfterRenderPermission: modifyAfterRenderPermission,
    requiredGuardianSignForIndirectServicePermission: requiredGuardianSignForIndirectServicePermission,
    canOnlyAddSignForTheirNotes: canOnlyAddSignForTheirNotes,
    latitude: state.appConfig.latitude,
    longitude: state.appConfig.longitude,
    clockInLatitude: state.appConfig.clockInLatitude,
    clockInLongitude: state.appConfig.clockInLongitude,
    clockOutLatitude: state.appConfig.clockOutLatitude,
    clockOutLongitude: state.appConfig.clockOutLongitude,   
  };
}

export default connect(mapStateToProps, { getMasterData, getSoapAction, createClaimAction, getAppointmentById, savePatientSoapAction, updateServiceCodeBlockedUnits, getAppConfigList, getPatientProfileDetails, saveEncounterSigns, getGeoLocation, getPreviousSessionNotesDetails, getGeoLocationClockIn, getGeoLocationClockOut, saveClockInTimeIntoAppointment, saveClockOutTimeIntoAppointment })(SessionNotes_RBT_TFABA);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_TFABA/SessionNotes_RBT_TFABA.js